module.exports = __webpack_public_path__ + "static/media/big-cell.1e6f2753.png";